import React, { useEffect, useRef, useState } from 'react'
import settingsImg from '../../../assets/images/Topbar/settingsImg.svg'
import notificationImg from '../../../assets/images/Topbar/notificationImg.svg'
import switchTiClient from '../../../assets/images/switch-to-client-image.svg'
import { Dropdown, Modal } from 'react-bootstrap';
import singleUpload from '../../../assets/images/UserManagement/single upload.svg'
import bulkUpload from '../../../assets/images/UserManagement/bulk upload.svg'
import SbCancelBtn, { SBSaveUpdateBtn } from '../../Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import { loadNotificationsData, loadSingleNotificationsData, postSwitchToSuperAdminDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication';
import { useDispatch, useSelector } from 'react-redux';
import { FaCheckDouble } from "react-icons/fa";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

function Header() {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedUserName = signInDetails ? signInDetails[0].UserName : null;
    const storedEmail = signInDetails ? signInDetails[0].EmailID : null;
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null;
    const signInType = signInDetails ? signInDetails[0].SignInType : null;
    const storedImg = signInDetails ? signInDetails[0].Image : null;
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));
    const PreviousSuperAdminName = sessionStorage.getItem('PreviousSuperAdminName');
    const PreviousSuperAdminEmailId = sessionStorage.getItem('PreviousSuperAdminEmailId');
    const PreviousSuperAdminID = JSON.parse(sessionStorage.getItem('PreviousSuperAdminID'));
    const PreviousSuperAdminImage = sessionStorage.getItem('PreviousSuperAdminImage');

    const dispatch = useDispatch();
    const { notifications = [] } = useSelector((state => state.data));
    const [showDropdown, setShowDropdown] = useState(false);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showSwitchModal, setShowSwitchModal] = useState(false);
    const [showCustomerListModal, setShowCustomerListModal] = useState(false);
    const [showCard, setShowCard] = useState(false);

    const handleToggleCard = () => {
        setShowCard(prev => !prev);
    };

    const handleDropdownToggle = () => setShowDropdown(!showDropdown);
    const handleProfileDropdownToggle = () => setShowProfileDropdown(!showProfileDropdown);

    const navigate = useNavigate();
    const handleLogoutClick = () => {
        setShowLogoutModal(true); // Show the logout confirmation modal
        setShowProfileDropdown(false); // Close the profile dropdown
    };

    const moduleId = 2;
    const handleSwitchToClient = () => {
        // setShowCustomerListModal(true);
        // e.preventDefault(); // Prevent default anchor behavior
        // window.location.href = '/#/customermanagement'; // Navigate to login-in route
        navigate('/customermanagement', { state: { isSwitchToClient: true, moduleId } })
    };

    const handleNavigateToCustomerConfirm = (e) => {
        e.preventDefault(); // Prevent default anchor behavior
        // window.location.href = '/#/customermanagement'; // Navigate to login-in route
        setShowCustomerListModal(false);
        navigate('/customermanagement', { state: { isSwitchToClient: true, moduleId } })
    }

    const handleSwitchToSuperAdmin = () => {
        setShowSwitchModal(true);
    };
    const handleSwitchClientCancel = () => {
        setShowSwitchModal(false);
    }

    const handleNavigateToCustomerCancel = () => {
        setShowCustomerListModal(false);
    }

    // const handleLogoutConfirm = () => {
    //     sessionStorage.clear(); // Clear session storage
    //     window.location.href = "/";
    // };

    const handleLogoutConfirm = () => {
        setTimeout(() => {
            // Clear sessionStorage in current tab
            sessionStorage.clear();

            // Trigger logout across all tabs
            localStorage.setItem("logout", Date.now());

            // Redirect to login/home
            window.location.href = "/";
        }, 1000); // 5000ms = 5 seconds
    };

    const handleSwitchClientConfirm = (e) => {
        e.preventDefault();

        let SigninID = null;

        if (signInType === "SuperAdmin") {
            SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
        } else if (signInType === "ClientAdmin") {
            SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
        } else if (signInType === "User") {
            SigninID = signInDetails[0].UserID; // Use UserID for User type
        }

        const data = {
            "SigninID": PreviousSuperAdminID,
            "CompanyID": PreviousCompanyID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };
        dispatch(postSwitchToSuperAdminDatas(requestOption, handleSwitchClientCancel, navigate));

    };

    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowNotificationDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        fetchNotificationData();
    }, []);

    const fetchNotificationData = () => {
        dispatch(loadNotificationsData())
    }

    // const handleNotifications = () => {
    //     dispatch(loadNotificationsData())
    // }

    const handleClick = (notificationId) => {
        dispatch(loadSingleNotificationsData(notificationId, fetchNotificationData));
    }

    return (
        <div className='header-container'>
            {/* <img src={settingsImg} alt="" /> */}
            {/* Conditionally render the settings image */}
            {signInType !== 'User' && (
                <Dropdown show={showDropdown} onToggle={handleDropdownToggle} className='settings-dropdown'>

                    <Dropdown.Toggle variant="link" className="no-chevron" onClick={handleDropdownToggle}>
                        <img src={settingsImg} alt="Settings" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item href="/settings">
                            <img src={singleUpload} alt="" />&nbsp;&nbsp;
                            Settings</Dropdown.Item>
                        {signInType !== 'ClientAdmin' && <Dropdown.Item onClick={handleSwitchToClient}>
                            <img src={bulkUpload} alt="" />&nbsp;&nbsp;
                            Switch to Client</Dropdown.Item>}
                        {PreviousCompanyID && <Dropdown.Item onClick={handleSwitchToSuperAdmin}>
                            <img src={bulkUpload} alt="" />&nbsp;&nbsp;
                            Switch to SuperAdmin</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            )}
            {/* <img src={notificationImg} alt="" /> */}
            <div style={{ position: "relative" }} ref={dropdownRef} className='notification-container'>
                <div className="notification-icon-wrapper" onClick={() => setShowNotificationDropdown(!showDropdown)}>
                    <img
                        src={notificationImg}
                        alt="Notifications"
                        style={{ cursor: "pointer" }}
                    // onClick={handleNotifications}
                    />
                    {notifications?.some(note => !note.IsRead) && (
                        <span className="notification-red-dot"></span>
                    )}
                </div>

                {showNotificationDropdown && (
                    <div className="notification-dropdown">
                        <div className="notification-header">
                            Notifications
                        </div>
                        <div className={`notification-item-container ${notifications.length === 0 ? "empty" : ""}`}>
                            {notifications.length > 0 ? (
                                notifications.map((note) => (
                                    <div className="notification-item" key={note.id} onClick={() => handleClick(note.NotificationUserID)}>
                                        <p className='notification-modulename'>{note.ModuleName}</p>
                                        <div className="note-text">{note.Message}</div>
                                        <div className='notification-date-passmark'>
                                            <div className="note-time">{dayjs(note.CreatedDate).fromNow()}</div>
                                            <FaCheckDouble className={`passmark ${note.IsRead ? "read" : ""}`} />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-notifications">No data found</div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {PreviousCompanyID && <img
                src={switchTiClient}
                alt=""
                style={{ cursor: 'pointer', position: 'relative' }}
                onClick={handleToggleCard}
            />}
            {showCard && (
                <div className="card mt-3 p-3 shadow sw-card-data">
                    <p>You are now working under the client instance : &nbsp;<strong>{storedCompanyName}</strong></p>
                    {/* <p><strong>Name:</strong> {storedUserName}</p>
                    <p><strong>Email:</strong> {storedEmail}</p> */}
                </div>
            )}
            <Dropdown show={showProfileDropdown} onToggle={handleProfileDropdownToggle} className='settings-dropdown'>
                <Dropdown.Toggle variant="link" className="no-chevron" onClick={handleProfileDropdownToggle}>
                    <div className='header-profile-div'>
                        {PreviousCompanyID ?
                            <img
                                // src={profileImg}
                                src={PreviousSuperAdminImage}
                                alt=""
                                style={{ height: "30px", width: '30px', borderRadius: '50%' }}
                            />
                            : <img
                                // src={profileImg}
                                src={storedImg}
                                alt=""
                                style={{ height: "30px", width: '30px', borderRadius: '50%' }}
                            />}
                        <div className='header-user-name'>
                            <span>{PreviousCompanyID ? PreviousSuperAdminName : storedUserName}</span>
                            <p>{PreviousCompanyID ? PreviousSuperAdminEmailId : storedEmail}</p>
                        </div>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item href="/userProfile">
                        <img src={singleUpload} alt="" />&nbsp;&nbsp;
                        Profile Settings</Dropdown.Item>
                    <Dropdown.Item onClick={handleLogoutClick}>
                        <img src={bulkUpload} alt="" />&nbsp;&nbsp;
                        Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} className='save-custom-view-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to logout?</p>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={() => setShowLogoutModal(false)} />
                    <SBSaveUpdateBtn btnName="Yes" onClickEffect={handleLogoutConfirm} />
                </Modal.Footer>
            </Modal>

            {/* Switch Modal */}
            <Modal show={showSwitchModal} onHide={handleSwitchClientCancel} className='sw-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Switch to SuperAdmin
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to switch to SuperAdmin
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleSwitchClientCancel} />
                    <SBSaveUpdateBtn btnName="Confirm" onClickEffect={handleSwitchClientConfirm} />
                </Modal.Footer>
            </Modal>

            <Modal show={showCustomerListModal} onHide={handleNavigateToCustomerCancel} className='sw-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Switch to Client
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Select the Customer from the list
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleNavigateToCustomerCancel} />
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={handleNavigateToCustomerConfirm} />
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Header
